var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"5d254ed674da39611aca20287ffa9d5e8b744c19"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["user-settings-spa@didomi"]={id:"5d254ed674da39611aca20287ffa9d5e8b744c19"};
      